(function () {
  function avvia(sez) {
    if (!sez || sez.dataset.rfcPronta) return;
    sez.dataset.rfcPronta = '1';

    // descrizione: il pulsante compare solo se il testo è più lungo di due righe
    var descr = sez.querySelector('[data-rfc-descr]');
    if (descr) {
      var testo = descr.querySelector('.rfc-descr__testo');
      var leggi = descr.querySelector('[data-rfc-leggi]');
      if (testo.scrollHeight > testo.clientHeight + 2) leggi.hidden = false;
      leggi.addEventListener('click', function () {
        var aperta = descr.classList.toggle('aperta');
        leggi.textContent = aperta ? 'Mostra meno' : 'Leggi di più';
        leggi.setAttribute('aria-expanded', aperta);
      });
    }

    // guida in fondo
    var seo = sez.querySelector('[data-rfc-seo]');
    var leggiSeo = sez.querySelector('[data-rfc-leggi-seo]');
    if (seo && leggiSeo) {
      if (seo.scrollHeight <= seo.clientHeight + 4) { seo.classList.add('aperto'); leggiSeo.hidden = true; }
      leggiSeo.addEventListener('click', function () {
        var aperta = seo.classList.toggle('aperto');
        leggiSeo.textContent = aperta ? 'Mostra meno' : 'Leggi tutta la guida';
        leggiSeo.setAttribute('aria-expanded', aperta);
      });
    }

    // ordina: tiene i filtri attivi
    var ordina = sez.querySelector('[data-rfc-ordina]');
    if (ordina) {
      ordina.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', ordina.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    // pannello dei filtri
    var velo = sez.querySelector('[data-rfc-velo]');
    var ultimo = null;
    function chiudi() {
      sez.querySelectorAll('[data-rfc-pannello]').forEach(function (p) { p.hidden = true; });
      if (velo) velo.hidden = true;
      document.documentElement.style.overflow = '';
      if (ultimo) ultimo.focus();
    }
    sez.querySelectorAll('[data-rfc-apri]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = sez.querySelector('[data-rfc-pannello="' + b.dataset.rfcApri + '"]');
        if (!p) return;
        ultimo = b;
        p.hidden = false;
        if (velo) velo.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var x = p.querySelector('[data-rfc-chiudi]');
        if (x) x.focus();
      });
    });
    sez.querySelectorAll('[data-rfc-chiudi]').forEach(function (b) { b.addEventListener('click', chiudi); });
    // riapre il pannello dopo aver scelto un filtro, così si possono sceglierne altri
    if (window.location.hash === '#filtri') {
      var bf = sez.querySelector('[data-rfc-apri="filtri"]');
      if (bf) bf.click();
      if (history.replaceState) history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    // fasce di prezzo pronte
    sez.querySelectorAll('[data-rfc-fascia]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = new URL(window.location.href);
        u.searchParams.delete(b.dataset.pmin); u.searchParams.delete(b.dataset.pmax); u.searchParams.delete('page');
        if (b.getAttribute('aria-pressed') !== 'true') {
          if (b.dataset.min) u.searchParams.set(b.dataset.pmin, b.dataset.min);
          if (b.dataset.max) u.searchParams.set(b.dataset.pmax, b.dataset.max);
        }
        u.hash = 'filtri';
        window.location.href = u.toString();
      });
    });
    if (velo) velo.addEventListener('click', chiudi);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chiudi(); });

    // carica altri senza ricaricare la pagina
    var griglia = sez.querySelector('[data-rfc-griglia]');
    var carica = sez.querySelector('[data-rfc-carica]');
    if (griglia && carica) {
      carica.addEventListener('click', function (e) {
        e.preventDefault();
        if (carica.getAttribute('aria-busy') === 'true') return;
        carica.setAttribute('aria-busy', 'true');
        fetch(carica.href, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nuova = doc.querySelector('[data-rfc-griglia]');
            if (nuova) Array.prototype.slice.call(nuova.children).forEach(function (c) { if (!c.classList.contains('rfc-t')) griglia.appendChild(c); });
            var t = doc.querySelector('[data-rfc-altri-testo]'), b = doc.querySelector('[data-rfc-altri-barra]'), c2 = doc.querySelector('[data-rfc-carica]');
            var tQui = sez.querySelector('[data-rfc-altri-testo]'), bQui = sez.querySelector('[data-rfc-altri-barra]');
            if (t && tQui) tQui.textContent = t.textContent;
            if (b && bQui) bQui.style.width = b.style.width;
            if (c2) { carica.href = c2.getAttribute('href'); carica.removeAttribute('aria-busy'); }
            else carica.remove();
          })
          .catch(function () { window.location.href = carica.href; });
      });
    }

    // bollino Google: compare dopo un attimo, si chiude per la sessione
    var bollino = sez.querySelector('[data-rfc-bollino]');
    if (bollino) {
      var chiuso = false;
      try { chiuso = sessionStorage.getItem('rfcBollino') === '0'; } catch (e) {}
      if (!chiuso) setTimeout(function () { bollino.hidden = false; }, 1800);
      var x = bollino.querySelector('[data-rfc-bollino-x]');
      if (x) x.addEventListener('click', function () {
        bollino.hidden = true;
        try { sessionStorage.setItem('rfcBollino', '0'); } catch (e) {}
      });
    }
  }
  function tutte() { document.querySelectorAll('[data-rfc]').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte); else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
